import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'
import { deserializeDate } from 'utils/date'
import { setRoutingServiceDate } from 'slices/customer/customerDetailsSlice'
import HHDateCalendar from 'components/common/HHDateCalendar'
import RoutingCalendarLegend from './RoutingCalendarLegend'

const RoutingCalendar = ({ value: controlledValue, onChange: controlledOnChange, ...rest }) => {
  const dispatch = useDispatch()
  const isControlled = controlledValue !== undefined

  const serializedServiceDate = useSelector(state => get(state, 'CustomerDetails.routing.serializedServiceDate'))
  const reduxDate = useMemo(() => (serializedServiceDate ? deserializeDate(serializedServiceDate) : new Date()), [serializedServiceDate])

  const currentDate = isControlled ? controlledValue : reduxDate

  const handleChange = useCallback(
    newDate => {
      if (isControlled) {
        controlledOnChange?.(newDate)
      } else {
        dispatch(setRoutingServiceDate(newDate))
      }
    },
    [dispatch, isControlled, controlledOnChange]
  )

  return <HHDateCalendar {...rest} value={currentDate} onChange={handleChange} legend={<RoutingCalendarLegend />} />
}

RoutingCalendar.propTypes = {
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
}

export default RoutingCalendar
